import { render, staticRenderFns } from "./NewServicesList.vue?vue&type=template&id=47f46e92&scoped=true&"
import script from "./NewServicesList.vue?vue&type=script&lang=js&"
export * from "./NewServicesList.vue?vue&type=script&lang=js&"
import style0 from "./NewServicesList.vue?vue&type=style&index=0&id=47f46e92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f46e92",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47f46e92')) {
      api.createRecord('47f46e92', component.options)
    } else {
      api.reload('47f46e92', component.options)
    }
    module.hot.accept("./NewServicesList.vue?vue&type=template&id=47f46e92&scoped=true&", function () {
      api.rerender('47f46e92', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/NewServicesList.vue"
export default component.exports